import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
//import {Helmet} from "react-helmet";
import API from '../api';
import Settings from '../constants/Settings';

import {
  Box,
} from 'grommet';

import Content from '../utils/RenderContent';
import Analytics from '../utils/Analytics';
import RenderHelmet from '../utils/RenderHelmet';
import PageWrap from "../components/PageWrap";
//import NotFound from '../components/NotFound';

const NominatingProcess = (props) => {
    const { match, t, i18n } = props;
    const [content, setContent] = useState(false);

    const loadContent = () => {
      API.getPageBySlug(i18n, 'nominating-process').then( (res) => {
        var inlineContent = res.items[0];
        setContent(inlineContent);
        setTimeout(checkForHash, 500);
      })
      .catch(console.error)
    }

    // Similar to componentDidMount and componentDidUpdate:
    // Empty array as second param so code only runs once
    useEffect(() => {
      Analytics.TrackPageView(window.location.pathname)
      loadContent()
    }, []);

    const checkForHash = () => {
      if (props.location.hash){
        var hashElement = document.getElementById(props.location.hash.replace('#',''))
        if (hashElement){
          hashElement.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }

    return (
      <Box id="page">
        <RenderHelmet content={content} match={match} t={t} i18n={i18n} />
        <PageWrap content={content}>
          <Content content={content} match={match} t={t} i18n={i18n} />
        </PageWrap>
      </Box>
    );
}

const PageTranslated = withTranslation("translations")(NominatingProcess);
export default PageTranslated
